import axios from 'axios'
import { message } from 'ant-design-vue'

const request = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '' : (process.env.VUE_APP_API_BASE_URL || ''),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

request.interceptors.request.use(
  config => {
    // Skip data wrapping for file uploads
    if (config.skipInterceptor) {
      return config
    }
    
    const sessionId = localStorage.getItem('sessionId')
    if (sessionId) {
      config.data = {
        sessionId: sessionId,
        data: config.data || {}
      }
    } else {
      config.data = {
        sessionId: '',
        data: config.data || {}
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  response => {
    const res = response.data
    
    if (res.code === '0') {
      return res
    } else {
      message.error(res.msg || '请求失败')
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
  },
  error => {
    console.error('请求错误:', error)
    
    if (error.response) {
      switch (error.response.status) {
        case 400:
          message.error('请求参数错误')
          break
        case 401:
          message.error('登录已过期，请重新登录')
          localStorage.removeItem('sessionId')
          localStorage.removeItem('user')
          window.location.href = '/login'
          break
        case 403:
          message.error('没有权限访问')
          break
        case 404:
          message.error('请求的资源不存在')
          break
        case 500:
          message.error('服务器内部错误')
          break
        default:
          message.error('网络错误，请稍后重试')
      }
    } else {
      message.error('网络连接失败，请检查网络设置')
    }
    
    return Promise.reject(error)
  }
)

export default request